import { useState } from "react";
import { HardDrive } from "lucide-react";

import { Button } from "@/components/ui/Button";
import { useAuthStore } from "@/store/auth";

import { useQuota } from "../hooks";
import { formatBytes, usedPercent } from "../utils";
import { CeoQuotaPanel } from "./CeoQuotaPanel";

export function QuotaBar() {
  const { data } = useQuota();
  const isCeo = useAuthStore((s) => s.user?.is_ceo);
  const [ceoOpen, setCeoOpen] = useState(false);

  const used = data?.used_bytes ?? 0;
  const quota = data?.quota_bytes ?? 0;
  const pct = usedPercent(used, quota);
  const nearFull = pct >= 90;

  return (
    <div className="flex items-center gap-4 border border-[var(--color-border)] bg-[var(--color-bg-surface)] px-4 py-3">
      <HardDrive size={18} className="text-[var(--color-text-muted)] flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between text-xs font-mono text-[var(--color-text-secondary)] mb-1">
          <span>Wykorzystana przestrzeń</span>
          <span>
            {formatBytes(used)} / {formatBytes(quota)} ({pct}%)
          </span>
        </div>
        <div className="h-2 bg-[var(--color-bg-base)] overflow-hidden">
          <div
            className={`h-full transition-[width] ${nearFull ? "bg-[var(--color-primary)]" : "bg-blue-600"}`}
            style={{ width: `${pct}%` }}
          />
        </div>
      </div>
      {isCeo && (
        <Button size="sm" variant="secondary" onClick={() => setCeoOpen(true)}>
          Limity
        </Button>
      )}
      <CeoQuotaPanel open={ceoOpen} onClose={() => setCeoOpen(false)} />
    </div>
  );
}
